module.exports = __webpack_public_path__ + "media/images/redesign-images/icons/icon-money-ce82f4f0cbbea32ac26878d56063d815.svg";